<template>
    <div>
        <b-modal
            id="confirm_select_booking_modal"
            modal-class=""
            centered
            hide-header
            hide-footer
            no-close-on-backdrop
            no-close-on-esc>
            <div class="modal-base">
                <div class="modal-base-head">
                    <p id="headline" v-html="headline"></p>
                    <!-- <p id="headline2" v-html="headline2"></p> -->
                </div>
                <div class="province mb-4" :class="{'disable-dropdown': dateList.length <= 0}">
                    <b-dropdown class="ddl-default"
                            variant="ddl-default"
                            menu-class="ddl-menu"
                            :class="{'placeholder-text':textDate == lblConfirmRedeem.date }"
                            :text="textDate"
                            :disabled="disableMonth">
                        <b-dropdown-item v-for="(v,k) in dateList" :key="k" @click="selectStore(v)">
                            {{v.text}}
                            <!-- {{localeCode.getLocaleCode() === 1054 ? v.name: v.name_en }} -->
                        </b-dropdown-item>
                    </b-dropdown>
                </div>

                <div class="province mb-3" :class="{'disable-dropdown': timeList.length <= 0}">
                    <b-dropdown class="ddl-default"
                            variant="ddl-default"
                            menu-class="ddl-menu"
                            :class="{'placeholder-text':textDatetime == lblConfirmRedeem.datetime }"
                            :text="textDatetime"
                            :disabled="disableMonth">
                        <b-dropdown-item v-for="(v,k) in timeList" :key="k" @click="selectDate(v)" >
                            <div v-if="v.IsAvailable">

                                {{v.timeFormat}}
                            </div>
                            <!-- {{localeCode.getLocaleCode().code === 1054 ? v.ProvinceName: v.ProvinceName_EN }} -->
                        </b-dropdown-item>
                    </b-dropdown>
                </div>

                <div class="mb-3">{{lblConfirmRedeem.news_from}}<span class="question-mark">{{lblConfirmRedeem.question_mark}}</span></div>

                <div class="province mb-4" :class="{'disable-dropdown': chanelList.length <= 0}">
                    <b-dropdown class="ddl-default"
                            variant="ddl-default"
                            menu-class="ddl-menu"
                            :class="{'placeholder-text':textChanel == lblConfirmRedeem.select_one }"
                            :text="textChanel"
                            :disabled="disableMonth">
                        <b-dropdown-item v-for="(v,k) in chanelList" :key="k" @click="selectChanel(v)" >
                            <div>
                                {{v.name}}
                            </div>
                            <!-- {{localeCode.getLocaleCode().code === 1054 ? v.ProvinceName: v.ProvinceName_EN }} -->
                        </b-dropdown-item>
                    </b-dropdown>
                </div>
                <div v-if="isShowinputChanel" class="text-wrapper">
                    <input type="text"
                        id="chanel_id"
                        class="bi-ib"
                        :placeholder="lblConfirmRedeem.answer_one"
                        v-model="chanel"
                        @input="onChange()" />
                </div>


                <div v-if="errorMessage" class="error-message">{{errorMessage}}</div>
                <div class="modal-base-footer btn-redeem-wrapper">
                    <button class="btn btn-cancel" @click="clickCancelSelectStore()">{{lblConfirmRedeem.cancel}}</button>
                    <button class="btn ml-2 btn-confirm"
                            :class="{'active': isActive && isChanelActive}"
                            @click="clickConfirmSelectStore()">{{lblConfirmRedeem.book}}</button>
                </div>
            </div>
        </b-modal>
        <modal view="select-store"
            :busModal="busModal"
            @modalAlertHidden="clickOkModalAlert($event)"></modal>
    </div>
</template>
<script>
//import Vue from "vue";
import Util from "@/helper/Utility.js";
import Moment from "moment";
import Locale from "@/helper/locale/locale.js";
import Account from '@/helper/AccountHelper.js';
import { TrackingService } from "@/helper/TrackingHelper";
// import BzbsAddress from '@/service/BzbsAddress.js';
import DiorApi from "@/service/dior/DiorApi.js";
import BzbsCampaign from "../../service/BzbsCampaign.js"

import Modal from '@/components/modal/Modal.vue';

export default {
    name: 'ConfirmSelectBookingModal',
     components: {

        Modal,
    },
    props: {
        lbl: Object,
        campaign: Object,
        busModal: Object,
        errorMessage: String,
    },
    data: function () {
        return {
            headline: '',
            headline2: '',
            message: '',
            texProvince: '',
            texDistrict: '',
            texBrance: '',
            texProvinceInfo3: '',
            texDistrictInfo3: '',
            texBranceInfo3: '',
            disableMonth: false,
            campaignIdRedeem: '',
            textDate: '',
            textDatetime: '',
            textChanel: '',
            chanel: '',
            isShowinputChanel: false,
            isChanelActive: false,

            lblConfirmRedeem: {},
            lblDate: {},
            monthList:[],
            provinceList:[],
            districList: [],
            branceList: [],
            storeList: [],
            dateList: [],
            timeList: [],
            chanelList: [],
            objInfo:{
                info3: '',
                info5: {
                    countercode: '',
                    name: '',
                    contact_number: '',
                    productcode:'',
                },

            },
            isActive: false,

            localeCode: Locale,
            date: '',
            // busModal: new Vue(),
            tracking: new TrackingService(this),
            userId: Account.getLineUserId()
        };
    },
    created: function () {

        console.log("confirmredeem");
        console.log(this.localeCode.getLocale());
        // this.storeList = this.campaign.subCampaignStyles2.styles;
        // console.log(this.storeList);
        this.setupChanel();
        this.getDateReserve();
    },
    mounted: function () {
        this.lblDate = this.lbl.date;
        this.lblConfirmRedeem = this.lbl.confirm_redeem;
        this.busModal.$on('showConfirmSelectBookingModal', this.initialConfirmModal);
        this.busModal.$on('hideConfirmSelectBookingModal', this.closeConfirmModal);
        this.busModal.$on('closeConfirmModal', this.closeConfirmModal)
        // this.getProviceStore();

    },
    methods: {
        getDateReserve: function () {
            var token = Account.getToken();
            console.log(this.campaign);
            // this.campaign.referenceCode = "TD21XMAS01";
            // this.campaign.locationId = "1564";
            DiorApi.getdateReserve(token, this.campaign.referenceCode, this.campaign.locationId).then((res) => {
                this.dateList = res.data;
                console.log(res);

            }).catch((err) => {
                if (err.response) {
                    console.log(err.response.data);

                }
                else {
                    this.showErrorConnectModal();
                    console.log(err);
                }
            });
        },
        getTimeReserve: function (data) {
            var token = Account.getToken();
            console.log(this.campaign);
            DiorApi.gettimeReserve(token, this.campaign.referenceCode, this.campaign.locationId, data.value).then((res) => {

                this.timeList = res.data;
                console.log(res);

            }).catch((err) => {
                if (err.response) {
                    console.log(err.response.data);

                }
                else {
                    this.showErrorConnectModal();
                    console.log(err);
                }
            });
        },
        setupChanel: function() {
            BzbsCampaign.apiGetchanelDior()
                .then((res) => {
                    this.chanelList = res.data;
                    console.log(res);
                })
                .catch((err) => {
                    console.log(err);
                    //this.errorApi(err);
                });
        },
        //Event
        clickConfirmSelectStore: function () {
            if (this.chanel) {

                this.objInfo.chanel =  this.objInfo.chanel + ": " + this.chanel;
            }
            this.$emit('clickConfirmSelectStore', { dataInfo: this.objInfo, tag: "booking", id: this.campaignIdRedeem });
            this.districList = [];
            this.branceList = [];
            //this.closeConfirmModal();

            let trackCamp = this.userId + "|" + this.campaign.id + "|" + this.campaign.name;
            this.tracking.event('service_list', 'click_EventBooking_success', trackCamp);
        },
        clickCancelSelectStore: function () {

            this.districList = [];
            this.branceList = [];
            this.objInfo.chanel = "";
            this.closeConfirmModal();
            this.isActive = false;
            this.$emit('clickCancelSelectStore');

            let trackCamp = this.userId + "|" + this.campaign.id + "|" + this.campaign.name;
            this.tracking.event('service_list', 'click_EventBooking_cancel', trackCamp);
        },
        //Function
        initialConfirmModal: function () {
            this.chanel = "";
            this.isShowinputChanel = false;
            this.headline = this.lblConfirmRedeem.headline_store;
            // this.headline2 = this.lblConfirmRedeem.headline_store2;

            this.textDate = this.lblConfirmRedeem.date;
            this.textDatetime = this.lblConfirmRedeem.datetime;
            this.textChanel = this.lblConfirmRedeem.select_one;

            this.message = this.lblConfirmRedeem.default1 + " " + this.campaign.pointPerUnit + " " + this.lblConfirmRedeem.default2;

            this.$bvModal.show('confirm_select_booking_modal');

        },
        closeConfirmModal: function () {
            this.$bvModal.hide('confirm_select_booking_modal');
        },
        //Utilities
        getTimerMessage: function (message, minutes) {
            var result = '';
            var days = '';
            var hours = '';
            var minuteAfterUsed = minutes;
            if (minuteAfterUsed >= 60) {
                hours = Math.floor(minuteAfterUsed / 60);
                if (hours >= 24) days = Math.floor(hours / 24);
            }

            if (days) result += days + ' ' + this.lblDate.days + ' ';
            if (hours) result += hours + ' ' + this.lblDate.hours + ' ';
            if (minutes / 60 > 0) result += (minutes % 60) + ' ' + this.lblDate.minutes_short;

            return Util.stringFormat(message, result);
        },
        getDrawMessage: function (message) {
            var expireDate = this.campaign.expireDate;
            var result = Moment.unix(expireDate).utc();
            var year = Moment.unix(expireDate).utc().format('YYYY');
            if (Locale.getLocaleCode() === 1054) year = result.get('year') + 543;

            var monthString = this.lblDate.month_short[result.format('M') - 1];
            var strDate = result.format('DD') + " " + monthString + " " + year
                        + ' | ' + result.format('HH:mm');

            return Util.stringFormat(message, strDate);
        },


        showAlertModal: function(title, message, btnOk, tag) {
            var configModal = {
                title: title,
                message: message,
                strBtnOk: btnOk,
                tag: tag,
            };
            this.busModal.$emit('showAlertModal', configModal);
        },
        clickOkModalAlert: function (e) {
           console.log(e);

        },
        selectStore: function (store) {

            // this.textStore = Locale.getLocaleCode() === 1054 ? store.name : store.name_en;
            this.textDate = store.text;
            this.date = store.value;
            this.getTimeReserve(store);
            //this.dateList = store.subitems;
        },
        selectDate: function (date) {
            this.textDatetime = date.timeFormat;
            this.campaignIdRedeem = this.campaign.id;
            var diorProfile = Account.getCacheDiorProfile()
            var tmpParam = {
                firstname: diorProfile.firstName,
                lastname: diorProfile.lastName,
                membercode: diorProfile.memberCode,
                contactNumber: diorProfile.mobileNumber,
                brance: this.campaign.defaultPrivilegeMessage,
                dateShow: this.textDate,
                date: this.date,
                // datetime: this.textDatetime,
                timeFrom: date.TimeFrom,
                timeTo: date.TimeTo,
                timeFormat: date.timeFormat,
                campaignId: this.campaignIdRedeem,
                masterCampaingId: this.campaign.id,
                counterCode: this.campaign.locationId,
                serviceCode: this.campaign.referenceCode,
                chanel: this.objInfo.chanel,

            }

            // this.objInfo = JSON.stringify(tmpParam);
            this.objInfo = tmpParam;

            this.isActive = true;
        },
        selectChanel: function (chanel) {
            console.log(chanel);
            this.textChanel = chanel.name;

            this.isShowinputChanel = false;

            if (!chanel.offline) {
                this.isChanelActive = false;
                this.objInfo.chanel = chanel.name;
                this.isShowinputChanel = true;

            } else {
                this.objInfo.chanel = chanel.name;
                this.isChanelActive = true;
            }
        },
        onChange: function () {

            if (this.chanel) {
                this.isChanelActive = true;
            } else {

                this.isChanelActive = false;
            }
        }
    }
}
</script>
<style lang="scss">
    $url-dropdown-icon: url('../../assets/img/01-register/dropdown@3x.png');
    @import "@/style/base/common.scss";
    @import "@/style/base/inputCustom/Dropdown.scss";
</style>
<style lang="scss" scoped>
    #headline {
        text-align: center;
        font-weight: bold;
    }
    #headline2 {
        text-align: center;
    }

    #message {
        text-align: center;
    }

    #confirm_select_booking_modal{

        .btn-redeem-wrapper {
            text-align: center;
            display: flex;
            flex-wrap: nowrap;

            .btn-cancel {
                width: 50%;
                background-color: white;
                color: black;
                border-color: black;
                border-radius: 0;
                min-height: 50px;
                text-transform: uppercase;
                font-weight: bold;
                letter-spacing: 2px;
            }

            .btn-confirm {
                width: 50%;
                background-color: #9c9c9c;
                color: white;
                border-color: #9c9c9c;
                border-radius: 0;
                pointer-events: none;
                min-height: 50px;
                text-transform: uppercase;
                font-weight: bold;
                letter-spacing: 2px;

                &.active {
                    background-color: black;
                    border-color: black;
                    pointer-events: auto;
                }
            }
        }

        .disable-dropdown {
            pointer-events: none;
        }


    }
    .error-message {
        color: red;
        padding-bottom: 20px;
    }
    .question-mark {
        font-family: century;
    }
    .text-wrapper {

        position: relative;
        width: 100%;
        height: 40px;
        z-index: 0;
        margin-bottom: 1.5rem;

        input {
            width: 100%;
            height: 100%;
            padding: 0 10px;
            border: 1px solid #a9a9a9;
            background: none;
            color: #000;
            text-align: left;
            z-index: 0;

                &:focus {
                   outline: none;
               }
        }
    }

</style>
